<template>
  <company-wrapper :company_logo="company_logo">
    <router-view />
  </company-wrapper>
</template>

<script>
  import { mapGetters } from 'vuex';
  import CompanyWrapper from './components/company-wrapper';

  export default {
    name: 'CompanyWrapperIndex',

    components: { CompanyWrapper },

    computed: {
      ...mapGetters('interview_talentq', ['company_logo'])
    }
  };
</script>
